import React from "react";
import {
  CollaboratorInfo,
  FontWeightEnum,
} from "../../../../../types/AppTypes";
import { getInitials } from "../../../../../utils/collaborators.utils";
import { BodyTyp } from "../../../../../components/Typography/Typography";
import {
  Avatar,
  AvatarDimensionsEnum,
} from "../../../../../components/core/Avatar/Avatar";
import { StyledAvatarSection } from "./AvatarSection.styled";

export const AvatarSection = ({
  collaborator,
  isComparison = false,
}: {
  collaborator: CollaboratorInfo;
  isComparison?: boolean;
}) => {
  return (
    <StyledAvatarSection $isComparison={isComparison}>
      <Avatar
        variant={AvatarDimensionsEnum.LARGE}
        collaboratorId={collaborator.id}
        initials={getInitials(collaborator.name, collaborator.surname)}
      />
      <div>
        <BodyTyp variant="1" fontWeight={FontWeightEnum.SEMIBOLD}>
          {collaborator.surname} {collaborator.name}
        </BodyTyp>
        <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
          {collaborator.internalGrade?.split(" - ")[1]}
        </BodyTyp>
      </div>
    </StyledAvatarSection>
  );
};
